const FOCUSABLE_SELECTOR =
	'input, select, textarea, button, label, a[href], .focusable';

export default function setTabFocusable(elem, focusable) {
	elem.querySelectorAll(FOCUSABLE_SELECTOR).forEach((e) => {
		e.setAttribute('tabindex', focusable ? '0' : '-1');
	});
}
